module.exports = __webpack_public_path__ + "img/progress_033.938d4444.png";